import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as signalR from '@microsoft/signalr';
import { ListHeader } from './EditUtils';
import DocList from './DocList';
import DocHome from './DocHome';
import EditArea from './EditArea';
import { showToast } from '../../Common/Messages';
import { excludeKeys } from '../../libs/Util';

const EditDocument = (props) => {
    const LoginStates = useSelector(state => state.login);
    
    const [connection, setConnection] = useState(null); 
    const [docList, setDocList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [current, setCurrent] = useState(null);
    const [activeNode, setActiveNode] = useState(null);
    const [originData, setOriginData] = useState(null);
    const [editorData, setEditorData] = useState(null);
    const [isUpdate, setIsUpdate] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [searchType, setSearchType] = useState("box");
    const [isSearch, setIsSearch] = useState(false);
    const [isEditable, setIsEditable] = useState(false);
   
    useEffect(() => {        
        const newConnection = new signalR.HubConnectionBuilder()
                                        .withUrl('/chathub')
                                        .withAutomaticReconnect().build();
        setConnection(newConnection);        
        return(()=>{
            if (connection) {
                connection.invoke("LeaveDocumentBoxGroup", LoginStates.userId, props.currentDocBox.docBoxPath);
            }
        });           
    }, []);   
    useEffect(() => {
        if (connection) {           
            connection.start()                
                .then(result => {
                    initializeList();
                    connection.on('RecevieDocList', (content, tree) => {                        
                        var treeJson = JSON.parse(tree);
                        var array = [];
                        array.push(treeJson !== '' ? treeJson : '{}');
                        setDocList(array);
                    });                    
                })
                .catch(e => console.log('Connection failed: ', e));
            
        }        
    }, [connection]);  
    useEffect(() => {
        setCurrent(null);
        if(connection) {
            initializeList();
        }
        if (props.currentDocBox?.editable) {
            setIsEditable(props.currentDocBox.editable === "Y");
        }
    }, [props.currentDocBox]);

    useEffect(()=>{
        if(current) {
            if(current?.name !== "" && current?.name !== current.item?.module) {
                updateDocList(docList, current);
            }
            if(current.path == null && docList.length > 0) {
                setDocumentPath();
            }
        } else {
            setOriginData(null);
            setEditorData(null);
            setActiveNode(null);
        }
    }, [current])
    useEffect(() => {
        scrollToNode();
    }, [activeNode]);
    useEffect(()=>{
        if(isUpdate) {
            sendTreeList();
            setIsUpdate(false);
        }
    }, [isUpdate])
    useEffect(() => {
        if (editorData && editorData.title) {
            setCurrent(prev => {
                if (!prev || prev.name === editorData.title) return prev;
                return {...prev, name: editorData.title};
            });
        }
    }, [editorData?.title]);
    useEffect(() => {
        if(keyword.trim() === "") {
            setFilteredList(docList);
        } else if(isUpdate) {
            filterDocList(docList, keyword);
        }
        if(current) scrollToNode();
    }, [keyword, docList]);

    useEffect(() => {
        setKeyword("");
        setIsSearch(false);
        setFilteredList(docList);
    }, [searchType]);
    
    const initializeList = async () => {        
        if (connection._connectionStarted) {
            try {
                await connection.invoke("JoinDocumentBoxGroup", LoginStates.userId, props.currentDocBox.docBoxPath);
                await connection.invoke("InitDocList",LoginStates.userId, props.currentDocBox.docBoxPath );

            } catch (e) {
                console.error('Sending message failed: ', e);
            }
        } else {
            console.log('No connection to server yet.');
        }
    }
    const sendTreeList = async () =>{        
        if (connection._connectionStarted) {
            try {
                await connection.invoke("SendDocList", LoginStates.userId, props.currentDocBox.docBoxPath, JSON.stringify(docList[0]));               
            } catch (e) {
                console.error('Sending message failed: ', e);
            }
        } else {
            console.log('No connection to server yet.');
        }
    }

    const updateDocList = (tree, node) => {
        const update = (children) => {
            for (const child of children) {
                // docId 및 이름 체크하여 변경
                if (child.docId === node.item?.docId) {
                    if(child.module !== node.name) {
                        child.module = node.name;
                        break;
                    }
                }
                // children이 있다면 재귀적으로 탐색
                if (child.children) {
                    update(child.children);
                }
            }
            return [...children];
        }
        setDocList(update(tree));
    }
    const filterDocList = (tree, keyword) => {
        const filterTree = (nodes, query) => {
            if (!query) return nodes;
            
            return nodes
                .map((node) => {
                if (node.module.toLowerCase().includes(query.toLowerCase())) {
                    return node;
                }
                if (node.children) {
                    const filteredChildren = filterTree(node.children, query);
                    if (filteredChildren.length > 0) {
                        return { ...node, children: filteredChildren };
                    }
                }
                return null;
                })
                .filter(Boolean);
        };
        setFilteredList([{...tree[0], children: filterTree(tree[0].children, keyword)}]);
    }
    const scrollToNode = () => {
        setTimeout(()=>{
            const wrapper = document.querySelector(".ctgr-tree");
            const offsetTop = activeNode ? document.querySelector(".on")?.offsetTop ?? 0 : 0;
            wrapper?.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }, 100);
    }
    const onClickNode = node => {
        if(!node.item.docId) return;
        if(current == null){
            getManual(node);
        }        
        else
            if(current.item?.docId != node.item.docId){
                if(checkIsChange("Cancle")) {   
                    getManual(node);
                }
            }
    };
    const getManual = async(node) => {
        const body = {            
            folderName: props.currentDocBox.docBoxPath,
            docId: node.item.docId,
        };
        const response = await fetch('api/Edit/GetManual', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json(); 
        if(response.status === 200 && result.message === "Success"){
            const data = result.data;
            const workId = data.workId ?? '';
            const qAId = data.qAId ?? '';
            
            const title = data.title !== "" ? data.title : node.name;
            const item = {
                title: title,
                tag: data.tag !== "" ? data.tag.includes("[") ? JSON.parse(data.tag) : data.tag.split(",") : [],
                access: data.access && data.access !== "" ? JSON.parse(data.access) : null,
                relationInfo: data.relationInfo !== "" ? JSON.parse(data.relationInfo) : [],
                versionInfo: "",
                data: data.document !== "" ? JSON.parse(data.document).data : {},
                workId: workId,
                qAId: qAId,
                workStatus: data.workStatus, 
                qAStatus: data.qAStatus !== "" ? parseInt(data.qAStatus) : 0,
                updateUserName: data.updateUserName, 
                updateUserId: data.updateUserId, 
                updateDate: data.updateDate,
                menuInfo: data.menuInfo !== "" ? JSON.parse(data.menuInfo) : [],
                faq: data.document !== "" ? JSON.parse(data.document).faq : []
            }
            
            node.item.workId = workId;
            node.item.qAId = qAId;
            setOriginData(item);
            setEditorData(item);    
            setCurrent(node);
            setActiveNode(node);
        } else {
            const error = result.error;
            if(error === "Fail Get Document") {
                showToast('danger', "문서 정보가 서버에 존재하지 않습니다. 리스트에서 삭제합니다.");
                removeNode(node);
            } else {
                showToast('danger', "문서를 조회할 수 없습니다.");
            }
        }
    }
    const addSubClick = async node => {    
        const updateTree = [...docList];
        if(!node.item.hasOwnProperty('children')){
            node.item.children = [{ module:'', docId:'add'}];
        }else{
            node.item.children.push({ module:'' , docId:'add'});
        }
        setDocList(updateTree);
    };
    const deleteNode = (currentNode, docId, parentNode = null, parentIndex = null, depth=0) => {       
        if (currentNode.docId === docId) {           
            if (parentNode) {                   
                parentNode.children.splice(parentIndex, 1);                   
                if (parentNode.children.length === 0 && parentIndex !== null && depth > 1) {
                    delete parentNode.children;
                }
            } else {                    
                currentNode = {};
            }
            return true;
        }
        // 자식 노드를 탐색해야 한다면 재귀적으로 탐색
        if (currentNode.children) {
            depth += 1;
            for (let i = 0; i < currentNode.children.length; i++) {
                const childNode = currentNode.children[i];
                const shouldDelete = deleteNode(childNode, docId, currentNode, i, depth);                
                if (shouldDelete) {
                    return true; 
                }
            }
        }
        return false;
    }
    const removeNode = async (node) => {
        if(node){
            if(deleteNode(docList[0], node.item.docId)) {
                sendTreeList();
                setCurrent(null);
            }
        } else {
            initializeList();             
        }
    };

    const checkIsChange = (type) => {   
        const origin = excludeKeys(originData, ['time', 'id']);
        const edit = excludeKeys(editorData, ['time', 'id']);
        const isEmpty = Object.keys(origin.data).length === 0;
        const isChange = !isEmpty && JSON.stringify(origin) !== JSON.stringify(edit); 
        if(type === "End") {
            if(!editorData.tag || editorData.tag.length === 0) {
                if (!window.confirm("태그를 입력하지 않을 경우 검수요청을 할 수 없습니다. 편집을 완료하시겠습니까?"))
                    return;
            }
            if(isChange) {
                const isContinue = window.confirm("변경된 내용이 존재합니다. 저장 후 완료하시겠습니까?");
                return isContinue;
            }
        } else if(type === "Cancle") {
            if(isChange) {
                const isCancle = window.confirm("저장하지 않은 편집 내용은 반영되지 않습니다. 계속 진행하겠습니까?");
                if(isCancle) initializeList();
                return isCancle;
            }
        }     
        return true;
    }
    const NewDocument = async (node, data) => {
        const userId = LoginStates.userId;
        const docData = JSON.stringify({title: node.item.module, tag: data?.tag ?? [], versionInfo: "", relationInfo: data?.relationInfo ?? [], data: data?.data ?? {}});
        const body = {
            FolderName: props.currentDocBox.docBoxPath,
            DevUserId: userId,
            DocData: docData,
            DocId: node.item.docId,
            CompanySeq: LoginStates.companySeq,
        };
        const response = await fetch('api/Edit/New', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });

        const result = await response.json();
        if(response.status === 200){
            node.item.docId = result.data.docId;   
            if(data) copyDocument(current.item.docId, `${props.currentDocBox.docBoxPath}/${result.data.docId}`);
            sendTreeList();            
            getManual(node);
        } else {
            showToast('danger', result.message);
        }
    }
    const copyDocument = async (fromDocId, toPath) => {
        const body = JSON.stringify({
            DocId: fromDocId,
            FolderName: toPath || ""
        });
        const response = await fetch('api/Edit/CopyManual', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: body
        });
        if(response.status === 200) {
            const result = await response.json();
            if(result === "") return null;
            else return result;
        } else return null;
    }
    const CopyToDocument = () => {
        const newNode = 
        {
            item: {
                docId: "add",
                module: current.item.module + " copy"
            },
            name: current.name + " copy",
            path: current.path
        }

        const addItemToSameLevel = (tree, targetId, newNode) => {
            for (let i = 0; i < tree.length; i++) {
                if (tree[i].docId === targetId) {
                    // targetId가 있는 위치 바로 다음(index + 1)에 새로운 노드 삽입
                    tree.splice(i + 1, 0, newNode.item);
                    return true;
                }
            }
        
            // 재귀적으로 children을 탐색하여 targetId 찾기
            for (let node of tree) {
                if (node.children) {
                    const found = addItemToSameLevel(node.children, targetId, newNode);
                    if (found) return true;
                }
            }
            return false;
        }
        const updateTree = [...docList];
        const result = addItemToSameLevel(docList[0].children, current.item.docId, newNode);
        if(!result) return;
        setDocList(updateTree);
        if(originData.data?.blocks) {
            originData.data?.blocks.forEach(block => {
                delete block.id;
            });
        }
        NewDocument(newNode, originData);
    }
    const setDocumentPath = () => {
        // 내부 재귀 함수
        const dfs = (node, path) => {
            // docId가 일치하면 경로 반환
            if (node.docId === current.item?.docId) {
                return path;
            }
            // 현재 노드의 이름을 경로에 추가
            path.push(node.module);
            // children이 있으면 재귀 탐색
            if (node.children && node.children.length > 0) {
                for (let child of node.children) {
                    const result = dfs(child, [...path]); // 경로를 복사해서 전달
                    if (result) return result; // 경로가 발견되면 반환
                }
            }
            return null; // 탐색 실패 시 null 반환
        }
        // 탐색 시작
        const path = dfs(docList[0], [])?.join("/") || "";
        setCurrent(prev => {
            if (!prev || prev.path === path) return prev;
            return {...prev, path: path};
        });
    }

    // Drag&Drop으로 위치 변경시, docList 업데이트
    const updateDocListPosition = (draggedNode, targetNode, dropAction) => {
        if(docList.length === 0) return;
        setIsUpdate(true);
        setDocList((prev) => {
            const removeNode = (nodes, nodeId) => {
                const result = [];
                let removedNode = null;
                for (const node of nodes) {
                    if (node.docId === nodeId) {
                        removedNode = node;
                    } else if (node.children) {
                        const { updatedChildren, removed } = removeNode(node.children, nodeId);
                        if (updatedChildren.length === 0) {
                            delete node.children;
                        } else {
                            node.children = updatedChildren;
                        }
                        result.push(node);
                        if (removed) removedNode = removed;
                    } else {
                        result.push(node);
                    }
                }
                return { updatedChildren: result, removed: removedNode };
            };

            const addNode = (nodes, targetId, newNode, position) => {
                return nodes.map((node) => {
                    if (node.docId === targetId) {
                        if (dropAction.child) {
                            node.children = [...(node.children || []), newNode];
                        } else if (dropAction.above) {
                            return [newNode, node];
                        } else if (dropAction.below) {
                            return [node, newNode];
                        }
                    } else if (node.children) {
                        node.children = addNode(node.children, targetId, newNode, position);
                    }
                    return node;
                }).flat();
            };

            const prevData = prev[0];
            const { updatedChildren, removed } = removeNode(prevData.children, draggedNode.item.docId);
            if (!removed) return prevData;

            const position = dropAction.above || dropAction.below || dropAction.child;

            let newData = prevData;
            if (position) {
                newData = {
                    ...prevData,
                    children: addNode(updatedChildren, targetNode.item.docId, removed, dropAction),
                };
            }

            return [newData];
        });
    }
  
    const handleKeyDown = (e) => {
        if(e.key === "Enter") {
            e.preventDefault();
            if(keyword.trim() === "") {
                setFilteredList(docList);
                if (current) scrollToNode();
            } else {
                if (searchType === "menu") {
                    setIsSearch(false);
                    search();
                } else {
                    setIsSearch(keyword.trim() !== "");
                    filterDocList(docList, keyword);
                }
            }
        }
    }
    
    const searchDocBoxDocumentsByMenuName = async (docBoxPath, keyword) => {
        const body = JSON.stringify({
            keyword: keyword,
            docBoxPath: docBoxPath
        });
        const response = await fetch('api/Edit/SearchDocBoxDocumentsByMenuName', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: body
        });
        if(response.status === 200) {
            const result = await response.json();
            return result.data?.table;
        } else return [];
    }

    const search = async () => {
        const result = await searchDocBoxDocumentsByMenuName(props.currentDocBox.docBoxPath, keyword);
        const idList = [];
        result.forEach(doc => {
            idList.push(doc.docID);
        })

        const filterTreeByIds = (nodes, ids) => {
            return nodes
                .map((node) => {
                    const shouldInclude = ids.includes(node.docId);

                    // 자식들 중 필터된 노드가 있으면 포함
                    if (node.children) {
                        const filteredChildren = filterTreeByIds(node.children, ids);
                        if (filteredChildren.length > 0 || shouldInclude) {
                            return { ...node, children: filteredChildren.length > 0 ? filteredChildren : node.children };
                        }
                    }

                    // 자기 자신이 포함 대상이면 전체 하위도 포함
                    if (shouldInclude) {
                        return { ...node };
                    }

                    return null;
                })
                .filter(Boolean);
        };
        const filterChildren = filterTreeByIds(docList[0].children, idList);
        setFilteredList([{...docList[0], children: filterChildren}]);
    }

    const filterStyle = {
        display: "flex",
        justifyContent: "space-between",
        borderRadius: "8px",
        border: "1px solid #ddd",
        background: "#FFF",
        padding: "8px"
    }
    return(
        <div className="edit-content">
            <div className="left-ctgr border-right">
                <ListHeader data={docList} currentCategory={props.currentDocBox.docBoxName} addSubClick={addSubClick} isEditable={isEditable} />
                <div style={{padding: "0 16px 10px"}}>
                    <div style={filterStyle}>
                        <select defaultValue={"box"} onChange={e => setSearchType(e.target.value)}>
                            <option value={"box"}>문서명</option>
                            <option value={"menu"}>메뉴명</option>
                        </select>
                        <input type="text" placeholder={"입력 후 엔터"} value={keyword} onChange={(e) => setKeyword(e.target.value)} onKeyDown={handleKeyDown} style={{width:"146px"}} />
                        <i className='icoKdc24 magnifier-b'></i>
                    </div>
                </div>
                <DocList data={filteredList} onClickNode={onClickNode} addSubClick={addSubClick} addDocument={NewDocument} removeNode={removeNode} current={current} updateDocList={updateDocListPosition} isSearch={isSearch} keyword={keyword} isEditable={isEditable} /> 
            </div>   
            {current === null ?
                <DocHome docBox={props.currentDocBox} setDocBox={props.setCurrentDocBox} setDocBoxList={props.setDocBoxList} getManual={getManual} />
            :
                <EditArea current={current} getManual={getManual} currentDocBox={props.currentDocBox} editorData={editorData} setCurrent={setCurrent} isEditable={isEditable}
                    setEditorData={setEditorData} checkIsChange={checkIsChange} removeNode={removeNode} setIsUpdate={setIsUpdate} CopyToDocument={CopyToDocument} copyDocument={copyDocument} />                        
            }
        </div>
    );
}

export default EditDocument;
